module.exports = __webpack_public_path__ + "img/08.6261edb1.png";